import { api } from './client';

export interface Branch {
  id: string;
  name: string;
  address: string | null;
  phone: string | null;
  active: boolean;
  sortOrder: number;
  /** What points at this location — what retiring it would affect. */
  counts: { staff: number; patients: number; appointments: number };
}

export interface CreateBranchInput {
  name: string;
  address?: string | null;
  phone?: string | null;
  sortOrder?: number;
}

export interface UpdateBranchInput extends Partial<CreateBranchInput> {
  active?: boolean;
}

export const branchesApi = {
  list: (includeInactive = false) => api.get<Branch[]>('/branches', { query: { includeInactive } }),
  create: (body: CreateBranchInput) => api.post<Branch>('/branches', body),
  update: (id: string, body: UpdateBranchInput) => api.patch<Branch>(`/branches/${id}`, body),
};
